// extracted by mini-css-extract-plugin
module.exports = {"billing_details":"billingHistory_billing_details__dPl29","underlined":"billingHistory_underlined__Pkaki","time_badge":"billingHistory_time_badge__GVQ8X"};